import type { StructuredValue } from '../nodes/structured-document.js';

export interface RetainedField { path: string[]; value: StructuredValue }
/** Keep unrecognized legacy fields separate from executable component configuration. */
export const collectRetainedFields = (source: unknown, normalized: unknown, previous: readonly RetainedField[] = []): RetainedField[] => {
  const entries = previous.map((field, index): RetainedField => {
    if (field && typeof field === 'object' && Array.isArray(field.path) && field.path.every(segment => typeof segment === 'string') && Object.hasOwn(field, 'value')) return structuredClone(field);
    return { path: ['retainedFields', String(index)], value: JSON.parse(JSON.stringify(field ?? null)) as StructuredValue };
  });
  const retained = new Map(entries.map(field => [JSON.stringify(field.path), field]));
  const visit = (before: unknown, after: unknown, path: string[]) => {
    if (!before || typeof before !== 'object' || !after || typeof after !== 'object') return;
    for (const [key, value] of Object.entries(before)) {
      if (!path.length && key === 'retainedFields') continue;
      const nextPath = [...path, key];
      if (!Object.hasOwn(after, key)) {
        // Removed array items are intentional normalization; only unknown named fields are retained.
        if (!Array.isArray(before) && value !== undefined) retained.set(JSON.stringify(nextPath), { path: nextPath, value: JSON.parse(JSON.stringify(value)) as StructuredValue });
      } else visit(value, (after as Record<string, unknown>)[key], nextPath);
    }
  };
  visit(source, normalized, []);
  return [...retained.values()];
};
